import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>404, Nothing Here</h1>
        </div>
    );
};

export default Notfound;